module.exports = __webpack_public_path__ + "static/rcc-chart-mobile-c2678c812764a28ba2bf1e6cb4e3d2af.png";